import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-268c8d3e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "verification-method-selection"
}
const _hoisted_2 = { class: "selection-hint mb-4 text-center" }
const _hoisted_3 = { class: "method-options" }
const _hoisted_4 = { class: "method-icon" }
const _hoisted_5 = { class: "method-info" }
const _hoisted_6 = { class: "method-name" }
const _hoisted_7 = { class: "method-description" }
const _hoisted_8 = { class: "method-icon" }
const _hoisted_9 = { class: "method-info" }
const _hoisted_10 = { class: "method-name" }
const _hoisted_11 = { class: "method-description" }
const _hoisted_12 = { class: "method-icon" }
const _hoisted_13 = { class: "method-info" }
const _hoisted_14 = { class: "method-name" }
const _hoisted_15 = { class: "method-description" }
const _hoisted_16 = {
  key: 1,
  class: "verification-input-section"
}
const _hoisted_17 = {
  key: 0,
  class: "verification-form"
}
const _hoisted_18 = { class: "method-title mb-4" }
const _hoisted_19 = { class: "form-group mb-3" }
const _hoisted_20 = { class: "form-label" }
const _hoisted_21 = { class: "d-flex gap-2" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1"
}
const _hoisted_24 = {
  key: 0,
  class: "success-message mt-2"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check-circle-fill me-1" }, null, -1))
const _hoisted_26 = { class: "form-text mt-2" }
const _hoisted_27 = {
  key: 0,
  class: "fw-bold"
}
const _hoisted_28 = {
  key: 1,
  class: "expiry-countdown mt-2"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-clock me-1" }, null, -1))
const _hoisted_30 = {
  key: 2,
  class: "expiry-expired mt-2"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-exclamation-circle me-1" }, null, -1))
const _hoisted_32 = {
  key: 1,
  class: "verification-form"
}
const _hoisted_33 = { class: "method-title mb-4" }
const _hoisted_34 = { class: "form-group mb-3" }
const _hoisted_35 = { class: "form-label" }
const _hoisted_36 = { class: "d-flex gap-2" }
const _hoisted_37 = ["disabled"]
const _hoisted_38 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1"
}
const _hoisted_39 = { class: "form-text mt-2" }
const _hoisted_40 = {
  key: 0,
  class: "fw-bold"
}
const _hoisted_41 = {
  key: 0,
  class: "expiry-countdown mt-2"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-clock me-1" }, null, -1))
const _hoisted_43 = {
  key: 2,
  class: "verification-form"
}
const _hoisted_44 = { class: "method-title mb-4" }
const _hoisted_45 = {
  key: 0,
  class: "setup-section mb-3"
}
const _hoisted_46 = { class: "alert alert-warning mb-3" }
const _hoisted_47 = { class: "fw-bold mb-2" }
const _hoisted_48 = { class: "small" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_51 = { class: "qr-code-container text-center mb-3" }
const _hoisted_52 = {
  key: 0,
  class: "spinner-border text-primary",
  role: "status"
}
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1))
const _hoisted_54 = [
  _hoisted_53
]
const _hoisted_55 = { key: 1 }
const _hoisted_56 = { class: "mt-3" }
const _hoisted_57 = { class: "alert alert-warning mb-3" }
const _hoisted_58 = { class: "small mb-2" }
const _hoisted_59 = { class: "fw-bold text-center" }
const _hoisted_60 = { class: "text-break fs-6" }
const _hoisted_61 = { class: "mt-3" }
const _hoisted_62 = { class: "form-group mb-3" }
const _hoisted_63 = { class: "form-label" }
const _hoisted_64 = { class: "form-text mt-2" }
const _hoisted_65 = {
  key: 3,
  class: "alert alert-danger mt-3",
  role: "alert"
}
const _hoisted_66 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_67 = { key: 1 }
const _hoisted_68 = { class: "d-flex gap-2" }
const _hoisted_69 = ["disabled"]
const _hoisted_70 = ["disabled"]
const _hoisted_71 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1"
}
const _hoisted_72 = { key: 1 }
const _hoisted_73 = { key: 2 }

import { ref, computed, nextTick, onMounted, onUnmounted } from "vue";
import { Message, Iphone, Lock, Back } from "@element-plus/icons-vue";
import { useStore } from "@/store";
import { useI18n } from "vue-i18n";
import TenantGlobalService from "@/projects/tenant/services/TenantGlobalService";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import axios from "axios";
import QRCode from "qrcodejs2";

type VerificationMethod = "email" | "sms" | "authenticator";


export default /*#__PURE__*/_defineComponent({
  __name: 'UnifiedTwoFaVerificationModal',
  emits: ["verified", "failed", "cancel"],
  setup(__props, { expose: __expose, emit: emits }) {

const { t } = useI18n();



const dialogVisible = ref(false);
const currentStep = ref(1);
const selectedMethod = ref<VerificationMethod | null>(null);
const verificationCode = ref("");
const errorMessage = ref("");
const emailSuccessMessage = ref("");
const isLoading = ref(false);
const isSending = ref(false);
const countdown = ref(0);
let countdownTimer: any = null;
const suppressCancel = ref(false);

const codeExpirySeconds = ref(0);
let codeExpiryTimer: any = null;
// 记录绝对到期时间戳，避免后台标签页 setInterval 被节流导致倒计时不准
let codeExpiryAt = 0;

const codeExpiryDisplay = computed(() => {
  if (codeExpirySeconds.value <= 0) return "";
  const m = Math.floor(codeExpirySeconds.value / 60);
  const s = codeExpirySeconds.value % 60;
  return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
});

// 响应式宽度检测
const isMobileWidth = ref(false);
const checkMobileWidth = () => {
  isMobileWidth.value = window.innerWidth < 768;
};

onMounted(() => {
  checkMobileWidth();
  window.addEventListener("resize", checkMobileWidth);
});

onUnmounted(() => {
  window.removeEventListener("resize", checkMobileWidth);
});

const store = useStore();
const user = computed(() => store.state.AuthModule.user);

// 新增状态
const userEmail = ref("");
const authTypes = ref<VerificationMethod[]>([]);
const isSetupMode = ref(false);
const currentEvent = ref("");
const qrCodeKey = ref("");
const qrCodeUrl = ref();
const showManualKey = ref(false);
const selectionHintText = ref("");

// 可用的验证方式（后续从后端获取）
const availableMethods = ref<VerificationMethod[]>([
  "email",
  "sms",
  "authenticator",
]);

// 限制只能输入数字
const onCodeInput = (value: string) => {
  verificationCode.value = value.replace(/[^0-9]/g, "");
  errorMessage.value = "";
};

// 显示弹窗
const show = (
  methods?: VerificationMethod[],
  email?: string,
  types?: VerificationMethod[],
  hintText?: string,
  event?: string
) => {
  if (methods && methods.length > 0) {
    availableMethods.value = methods;
  } else if (types && types.length > 0) {
    availableMethods.value = types;
  }
  if (email) {
    userEmail.value = email;
  }
  if (types) {
    authTypes.value = types;
  }
  selectionHintText.value = hintText || "";
  currentEvent.value = event || "";
  // reset suppress flag when opening
  suppressCancel.value = false;

  dialogVisible.value = true;
  verificationCode.value = "";
  errorMessage.value = "";
  emailSuccessMessage.value = ""; // 清除成功消息
  // 不要重置 countdown，保持冷却状态
  // countdown.value = 0;
  isSetupMode.value = false;
  qrCodeKey.value = "";
  showManualKey.value = false;

  // 特殊情况：如果 availableMethods 只有 authenticator 但 authTypes 为空，说明是首次设置，直接进入 setup 模式
  if (
    availableMethods.value.length === 1 &&
    availableMethods.value[0] === "authenticator" &&
    authTypes.value.length === 0
  ) {
    currentStep.value = 2;
    selectedMethod.value = "authenticator";
    isSetupMode.value = true;
    nextTick(() => {
      setupAuthenticator();
    });
  }
  // 如果只有一个验证方式，直接跳到第二步
  else if (availableMethods.value.length === 1) {
    currentStep.value = 2;
    selectedMethod.value = availableMethods.value[0];
    // 自动触发相应的验证流程
    nextTick(() => {
      if (
        selectedMethod.value === "authenticator" &&
        !authTypes.value.includes("authenticator")
      ) {
        isSetupMode.value = true;
        setupAuthenticator();
      } else if (selectedMethod.value === "email" && countdown.value === 0) {
        sendEmailCode();
      } else if (selectedMethod.value === "sms" && countdown.value === 0) {
        sendSMSCode();
      }
    });
  } else {
    // 多个验证方式，显示选择页面
    currentStep.value = 1;
    selectedMethod.value = null;
  }
};

// 选择验证方式
const selectMethod = async (method: VerificationMethod) => {
  selectedMethod.value = method;
  verificationCode.value = "";
  errorMessage.value = "";
  emailSuccessMessage.value = ""; // 清除成功消息

  // 先切换到第二步，让 DOM 渲染出来
  currentStep.value = 2;

  // 等待 DOM 更新
  await nextTick();

  // 检查 Authenticator 是否需要 setup
  if (
    method === "authenticator" &&
    !authTypes.value.includes("authenticator")
  ) {
    // 需要进入 setup 流程
    isSetupMode.value = true;
    await setupAuthenticator();
  } else if (method === "email" && countdown.value === 0) {
    // 只在倒计时为0时才发送邮箱验证码
    await sendEmailCode();
  } else if (method === "sms" && countdown.value === 0) {
    // 只在倒计时为0时才发送短信验证码
    await sendSMSCode();
  }
}; // 返回方式选择
const backToMethodSelection = () => {
  currentStep.value = 1;
  selectedMethod.value = null;
  verificationCode.value = "";
  errorMessage.value = "";
  emailSuccessMessage.value = ""; // 清除成功消息
  // 不再重置倒计时，保持冷却状态
  // countdown.value = 0;
  // if (countdownTimer) {
  //   clearInterval(countdownTimer);
  //   countdownTimer = null;
  // }
};

// 设置 Authenticator
const setupAuthenticator = async () => {
  isLoading.value = true;
  errorMessage.value = "";
  try {
    const response = await axios.post(
      "/api/v2/auth/auth-code/authenticator/setup",
      {
        email: userEmail.value || user.value.email,
      }
    );

    // API 返回 { sharedKey, authenticatorUri }
    const sharedKey =
      response.data.sharedKey || response.data.data?.sharedKey || "";
    const authenticatorUri =
      response.data.authenticatorUri ||
      response.data.data?.authenticatorUri ||
      "";

    if (sharedKey && authenticatorUri) {
      qrCodeKey.value = sharedKey;
      showManualKey.value = false;

      // 关键：先结束 loading 状态，让 v-else 块渲染出来
      isLoading.value = false;

      // 等待 DOM 更新，此时 qrCodeUrl 的 ref 才会绑定
      await nextTick();

      if (qrCodeUrl.value) {
        // 清除旧的二维码
        while (qrCodeUrl.value.firstChild) {
          qrCodeUrl.value.removeChild(qrCodeUrl.value.firstChild);
        }

        // 使用后端返回的 authenticatorUri 生成二维码
        new QRCode(qrCodeUrl.value, {
          text: authenticatorUri,
          width: 160,
          height: 160,
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.H,
        });
      }
    } else {
      throw new Error("Invalid response from server");
    }
  } catch (error: any) {
    errorMessage.value =
      error.response?.data?.message || "Failed to setup authenticator";
    MsgPrompt.error(errorMessage.value);
    isLoading.value = false;
  }
};

// 开始重发倒计时
const startCountdown = () => {
  countdown.value = 60;
  if (countdownTimer) {
    clearInterval(countdownTimer);
  }
  countdownTimer = setInterval(() => {
    countdown.value--;
    if (countdown.value <= 0) {
      if (countdownTimer) {
        clearInterval(countdownTimer);
        countdownTimer = null;
      }
    }
  }, 1000);
};

// 开始验证码有效期倒计时（10分钟）
const startExpiryCountdown = () => {
  // 用绝对到期时间，每次根据当前时间算剩余，离开页面再回来也准确
  codeExpiryAt = Date.now() + 600 * 1000;
  const tick = () => {
    const remain = Math.max(0, Math.ceil((codeExpiryAt - Date.now()) / 1000));
    codeExpirySeconds.value = remain;
    if (remain <= 0 && codeExpiryTimer) {
      clearInterval(codeExpiryTimer);
      codeExpiryTimer = null;
    }
  };
  if (codeExpiryTimer) {
    clearInterval(codeExpiryTimer);
  }
  tick();
  codeExpiryTimer = setInterval(tick, 1000);
};

// 发送邮箱验证码
const sendEmailCode = async () => {
  isSending.value = true;
  errorMessage.value = "";
  emailSuccessMessage.value = ""; // 清除之前的成功消息
  try {
    await axios.post("/api/v2/auth/auth-code/email", {
      email: userEmail.value || user.value.email,
      event: currentEvent.value || undefined,
    });
    // 不使用 MsgPrompt，而是显示在输入框下方
    emailSuccessMessage.value = t("tip.verificationCodeSentToEmail");
    startCountdown();
    startExpiryCountdown();
  } catch (error: any) {
    errorMessage.value =
      error.response?.data?.message || "Failed to send verification code";
    // 不使用 MsgPrompt，直接显示在输入框下方
  } finally {
    isSending.value = false;
  }
};

// 发送短信验证码
const sendSMSCode = async () => {
  isSending.value = true;
  errorMessage.value = "";
  try {
    await axios.post("/api/v1/user/otp/mobile", {
      // phone 从用户信息中获取
    });
    MsgPrompt.success("Verification code sent to your phone");
    startCountdown();
    startExpiryCountdown();
  } catch (error: any) {
    errorMessage.value =
      error.response?.data?.message || "Failed to send verification code";
    MsgPrompt.error(errorMessage.value);
  } finally {
    isSending.value = false;
  }
};

// 提交验证
const submitVerification = async () => {
  if (!verificationCode.value || verificationCode.value.length !== 6) {
    errorMessage.value = "Please enter 6-digit verification code";
    return;
  }

  isLoading.value = true;
  errorMessage.value = "";

  try {
    if (
      selectedMethod.value === "email" &&
      !authTypes.value.includes("email")
    ) {
      await axios.put("/api/v2/auth/auth-code/email/enable", {
        email: userEmail.value || user.value.email,
        code: verificationCode.value,
      });
      suppressCancel.value = true;
      dialogVisible.value = false;
      emits(
        "verified",
        verificationCode.value,
        selectedMethod.value as VerificationMethod
      );
      isLoading.value = false;
      return;
    }

    if (selectedMethod.value === "authenticator" && isSetupMode.value) {
      // Setup 模式：启用 authenticator
      await axios.put("/api/v2/auth/auth-code/authenticator/enable", {
        email: userEmail.value || user.value.email,
        code: verificationCode.value,
      });
      // 不在这里显示成功提示，由父组件处理
      // 关闭弹窗，让用户重新登录
      // Close programmatically without emitting cancel to parent
      suppressCancel.value = true;
      dialogVisible.value = false;
      emits(
        "verified",
        verificationCode.value,
        selectedMethod.value as VerificationMethod
      );
      isLoading.value = false;
      return;
    }

    // 普通验证模式：不调用验证API，直接emit给父组件处理
    // 父组件会将code和authType附加到/connect/token请求中进行验证
    // 保持 isLoading=true 状态，等待父组件验证完成后通过 closeModal 或 showError 来重置
    emits(
      "verified",
      verificationCode.value,
      selectedMethod.value as VerificationMethod
    );
    // 不在这里关闭弹窗，也不重置 isLoading，等待父组件验证成功后再关闭
  } catch (error: any) {
    errorMessage.value = t("tip.invalidCodePleaseTryAgain");
    verificationCode.value = ""; // 清空输入框
    isLoading.value = false;
    // 不再触发 failed 事件，也不关闭弹窗
  }
};

// 取消
const onCancel = () => {
  dialogVisible.value = false;
  if (suppressCancel.value) {
    // programmatic close - consume the flag and do not emit cancel
    suppressCancel.value = false;
    return;
  }
  emits("cancel");
};

// 关闭
const onClose = () => {
  if (countdownTimer) {
    clearInterval(countdownTimer);
    countdownTimer = null;
  }
  if (codeExpiryTimer) {
    clearInterval(codeExpiryTimer);
    codeExpiryTimer = null;
  }
  codeExpirySeconds.value = 0;
  // 重置倒计时，让下次打开可以立即发送
  countdown.value = 0;
  if (suppressCancel.value) {
    suppressCancel.value = false;
    return;
  }
  emits("cancel");
};

// 显示错误信息（供父组件调用）
const showError = (message: string) => {
  errorMessage.value = message;
  verificationCode.value = ""; // 清空输入框
  isLoading.value = false; // 重置加载状态
};

// 关闭弹窗（供父组件调用）
const closeModal = () => {
  // programmatic close should not trigger parent cancel
  suppressCancel.value = true;
  dialogVisible.value = false;
  isLoading.value = false; // 重置加载状态
};

__expose({
  show,
  showError,
  closeModal,
});

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogVisible.value,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((dialogVisible).value = $event)),
    title: _ctx.$t('fields.twoFactorAuthentication'),
    width: isMobileWidth.value ? '95%' : '500px',
    "close-on-click-modal": true,
    "close-on-press-escape": true,
    onClose: onClose
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_66, [
        (currentStep.value === 2 && availableMethods.value.length > 1)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              onClick: backToMethodSelection,
              disabled: isLoading.value,
              text: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, { class: "me-1" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Back))
                  ]),
                  _: 1
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("action.back")), 1)
              ]),
              _: 1
            }, 8, ["disabled"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_67)),
        _createElementVNode("div", _hoisted_68, [
          _createElementVNode("button", {
            class: "btn btn-sm btn-secondary",
            onClick: onCancel,
            disabled: isLoading.value
          }, _toDisplayString(_ctx.$t("action.cancel")), 9, _hoisted_69),
          (currentStep.value === 2)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-sm btn-primary",
                onClick: submitVerification,
                disabled: 
              !verificationCode.value || verificationCode.value.length !== 6 || isLoading.value
            
              }, [
                (isLoading.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_71))
                  : _createCommentVNode("", true),
                (isLoading.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_72, _toDisplayString(_ctx.$t("status.verifying")) + "...", 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_73, _toDisplayString(_ctx.$t("action.verify")), 1))
              ], 8, _hoisted_70))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    default: _withCtx(() => [
      (currentStep.value === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(selectionHintText.value || _ctx.$t("tip.pleaseSelectVerificationMethod")), 1),
            _createElementVNode("div", _hoisted_3, [
              (availableMethods.value.includes('email'))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "method-card",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (selectMethod('email')))
                  }, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_el_icon, { size: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Message))
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("fields.email")), 1),
                      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("tip.verifyViaEmail")), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (availableMethods.value.includes('sms'))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "method-card",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (selectMethod('sms')))
                  }, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_el_icon, { size: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Iphone))
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("fields.sms")), 1),
                      _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("tip.verifyViaSMS")), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (availableMethods.value.includes('authenticator'))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: "method-card",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (selectMethod('authenticator')))
                  }, [
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_el_icon, { size: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Lock))
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t("tip.authenticator")), 1),
                      _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("tip.verifyViaAuthenticator")), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (currentStep.value === 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            (selectedMethod.value === 'email')
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_el_icon, {
                      size: 24,
                      class: "me-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Message))
                      ]),
                      _: 1
                    }),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("tip.emailVerification")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t("fields.verificationCode")), 1),
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(_component_el_input, {
                        modelValue: verificationCode.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((verificationCode).value = $event)),
                        placeholder: _ctx.$t('fields.enterYourCode'),
                        size: "large",
                        maxlength: "6",
                        clearable: "",
                        onInput: onCodeInput,
                        onKeyup: _withKeys(submitVerification, ["enter"]),
                        class: "flex-1"
                      }, {
                        prefix: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Message))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder", "onKeyup"]),
                      _createElementVNode("button", {
                        class: "btn btn-sm btn-primary text-nowrap",
                        disabled: countdown.value > 0 || isSending.value,
                        onClick: sendEmailCode
                      }, [
                        (isSending.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_23))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(countdown.value > 0 ? `${countdown.value}s` : _ctx.$t("action.resend")), 1)
                      ], 8, _hoisted_22)
                    ]),
                    (emailSuccessMessage.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          _hoisted_25,
                          _createTextVNode(" " + _toDisplayString(emailSuccessMessage.value), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_26, [
                      _createTextVNode(_toDisplayString(_ctx.$t("tip.checkEmailForVerificationCode")) + " ", 1),
                      (userEmail.value || user.value.email)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_27, "(" + _toDisplayString(userEmail.value || user.value.email) + ")", 1))
                        : _createCommentVNode("", true)
                    ]),
                    (codeExpirySeconds.value > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                          _hoisted_29,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("tip.codeExpiresIn")) + " " + _toDisplayString(codeExpiryDisplay.value), 1)
                        ]))
                      : (codeExpirySeconds.value === 0 && emailSuccessMessage.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                            _hoisted_31,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t("tip.codeExpired")), 1)
                          ]))
                        : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            (selectedMethod.value === 'sms')
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createVNode(_component_el_icon, {
                      size: 24,
                      class: "me-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Iphone))
                      ]),
                      _: 1
                    }),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("tip.smsVerification")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.$t("fields.verificationCode")), 1),
                    _createElementVNode("div", _hoisted_36, [
                      _createVNode(_component_el_input, {
                        modelValue: verificationCode.value,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((verificationCode).value = $event)),
                        placeholder: _ctx.$t('fields.enterYourCode'),
                        size: "large",
                        maxlength: "6",
                        clearable: "",
                        onInput: onCodeInput,
                        onKeyup: _withKeys(submitVerification, ["enter"]),
                        class: "flex-1"
                      }, {
                        prefix: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Iphone))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder", "onKeyup"]),
                      _createElementVNode("button", {
                        class: "btn btn-sm btn-primary text-nowrap",
                        disabled: countdown.value > 0 || isSending.value,
                        onClick: sendSMSCode
                      }, [
                        (isSending.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_38))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(countdown.value > 0 ? `${countdown.value}s` : _ctx.$t("action.resend")), 1)
                      ], 8, _hoisted_37)
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _createTextVNode(_toDisplayString(_ctx.$t("tip.checkSMSForVerificationCode")) + " ", 1),
                      (user.value.ccc && user.value.phoneNumber)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_40, " (+" + _toDisplayString(user.value.ccc) + " " + _toDisplayString(user.value.phoneNumber) + ") ", 1))
                        : _createCommentVNode("", true)
                    ]),
                    (codeExpirySeconds.value > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                          _hoisted_42,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("tip.codeExpiresIn")) + " " + _toDisplayString(codeExpiryDisplay.value), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            (selectedMethod.value === 'authenticator')
              ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                  _createElementVNode("div", _hoisted_44, [
                    _createVNode(_component_el_icon, {
                      size: 24,
                      class: "me-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Lock))
                      ]),
                      _: 1
                    }),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("tip.authenticator")), 1)
                  ]),
                  (isSetupMode.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.$t("tip.setupGoogleAuthenticator")), 1),
                          _createElementVNode("div", _hoisted_48, [
                            _createTextVNode(" 1. " + _toDisplayString(_ctx.$t("tip.downloadAuthenticatorApp")), 1),
                            _hoisted_49,
                            _createTextVNode(" 2. " + _toDisplayString(_ctx.$t("tip.scanQRCode")), 1),
                            _hoisted_50,
                            _createTextVNode(" 3. " + _toDisplayString(_ctx.$t("tip.enter6DigitCode")), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_51, [
                          (isLoading.value && !qrCodeKey.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_52, _hoisted_54))
                            : (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                _createElementVNode("div", {
                                  class: "qr-code-wrapper",
                                  style: _normalizeStyle({ display: showManualKey.value ? 'none' : 'block' })
                                }, [
                                  _createElementVNode("div", {
                                    ref_key: "qrCodeUrl",
                                    ref: qrCodeUrl,
                                    class: "qrcode"
                                  }, null, 512),
                                  _createElementVNode("div", _hoisted_56, [
                                    _createElementVNode("a", {
                                      href: "javascript:void(0)",
                                      class: "text-primary small",
                                      onClick: _cache[5] || (_cache[5] = ($event: any) => (showManualKey.value = true))
                                    }, _toDisplayString(_ctx.$t("tip.cannotScanQRCode")), 1)
                                  ])
                                ], 4),
                                _createElementVNode("div", {
                                  style: _normalizeStyle({ display: showManualKey.value ? 'block' : 'none' }),
                                  class: "manual-key-section"
                                }, [
                                  _createElementVNode("div", _hoisted_57, [
                                    _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.$t("tip.manualKeyInstructions")), 1),
                                    _createElementVNode("div", _hoisted_59, [
                                      _createElementVNode("code", _hoisted_60, _toDisplayString(qrCodeKey.value), 1)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_61, [
                                    _createElementVNode("a", {
                                      href: "javascript:void(0)",
                                      class: "text-primary small",
                                      onClick: _cache[6] || (_cache[6] = ($event: any) => (showManualKey.value = false))
                                    }, _toDisplayString(_ctx.$t("tip.backToQRCode")), 1)
                                  ])
                                ], 4)
                              ]))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("label", _hoisted_63, _toDisplayString(_ctx.$t("fields.verificationCode")), 1),
                    _createVNode(_component_el_input, {
                      modelValue: verificationCode.value,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((verificationCode).value = $event)),
                      placeholder: _ctx.$t('fields.enterYourCode'),
                      size: "large",
                      maxlength: "6",
                      clearable: "",
                      onInput: onCodeInput,
                      onKeyup: _withKeys(submitVerification, ["enter"])
                    }, {
                      prefix: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Lock))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue", "placeholder", "onKeyup"]),
                    _createElementVNode("div", _hoisted_64, _toDisplayString(isSetupMode.value
                ? _ctx.$t("tip.enter6DigitCodeToComplete")
                : _ctx.$t("tip.enter6DigitCodeInAuthApp")), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (errorMessage.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                  _createElementVNode("small", null, _toDisplayString(errorMessage.value), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue", "title", "width"]))
}
}

})